import { useEffect, useState } from "react";
import { Box, Button, Divider, Typography } from "@mui/material";
import { IOperation } from "Models/Operation";
import { useIntl } from "react-intl";
import { useGetCountryByCodeQuery } from "redux/api/countryApi";

export const PreviousOperation = ({ operation }: { operation: IOperation }) => {
  const [showDetails, setShowDetails] = useState(false);
  const { formatMessage,locale } = useIntl();
  const [nationality, setNationality] = useState(operation.nationality||'');
  const { data: countryFound, refetch, isFetching, isSuccess:isCountrySucces, error:countryError } = useGetCountryByCodeQuery(
            { code: operation?.nationality, language: locale}
        );
  useEffect(() => {
          if (isCountrySucces && countryFound) {
              setNationality(countryFound);
          }
      }, [isCountrySucces, countryFound]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        marginBottom: "20px", // Se agrega separación inferior entre las cards
      }}
    >
      <Box
        sx={{
          border: "2px solid black",
          padding: "20px",
          width: "300px",
          borderRadius: "3px",
          fontFamily: "Arial, sans-serif",
          backgroundColor: "#f2f2f2",
          position: "relative",
        }}
      >
        <Typography sx={{ marginBottom: "8px" }}>
          <strong>{formatMessage({ id: "previous.operation.name" })}</strong> {operation.clientName}
        </Typography>
        <Divider sx={{ margin: "8px 0" }} />
        <Typography sx={{ marginBottom: "8px" }}>
          <strong>{formatMessage({ id: "previous.operation.operation.id" })}</strong> {operation.id}
        </Typography>
        <Divider sx={{ margin: "8px 0" }} />
        <Typography sx={{ marginBottom: "8px" }}>
          <strong>{formatMessage({ id: "previous.operation.amount" })}</strong> {operation.amount}€
        </Typography>
        {operation.verifiedOperation ?
          <Typography sx={{ marginBottom: "8px", color: "green" }}>
            <strong>{formatMessage({ id: "previous.operation.verified" })}</strong>
          </Typography>
          :
          <Typography sx={{ marginBottom: "8px", color: "red"  }}>
            <strong>{formatMessage({ id: "previous.operation.disrecommended" })}</strong>
          </Typography>
        }
        <Divider sx={{ margin: "8px 0" }} />
        {showDetails && (
          <Box sx={{ marginTop: "15px" }}>
            <Typography sx={{ marginBottom: "8px" }}>
              <strong>{formatMessage({ id: "previous.operation.date" })}</strong>{" "}
              {new Date(operation.operationDate).toLocaleDateString()}
            </Typography>
            <Typography sx={{ marginBottom: "8px" }}>
              <strong>{formatMessage({ id: "previous.operation.address" })}</strong> {operation.clientAddress}
            </Typography>
            <Typography sx={{ marginBottom: "8px" }}>
              <strong>{formatMessage({ id: "previous.operation.nationality" })}</strong> {nationality}
            </Typography>
            <Typography sx={{ marginBottom: "8px" }}>
              <strong>{formatMessage({ id: "previous.operation.status" })}</strong> {operation.status}
            </Typography>
          </Box>
        )}
      </Box>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => setShowDetails((prev) => !prev)}
        sx={{
          position: "absolute",
          bottom: "-10px",
          left: "50%",
          transform: "translateX(-50%)",
          padding: "5px 20px",
          whiteSpace: "nowrap",
        }}
      >
        {showDetails ? formatMessage({ id: "previous.operation.hide.details" }) : formatMessage({ id: "previous.operation.show.details" })}
      </Button>
    </Box>
  );
};
